export default "__VITE_ASSET__DKt$L_3X__"